import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/EN.svg'
import _imports_1 from '@/assets/icons/SE.svg'


const _hoisted_1 = { class: "cl-topbar" }
const _hoisted_2 = { class: "cl-topbar__left" }
const _hoisted_3 = { class: "cl-topbar__right" }
const _hoisted_4 = { class: "dropdown me-2" }
const _hoisted_5 = {
  class: "cl-topbar__lang-btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = {
  key: 0,
  class: "cl-lang-flag",
  src: _imports_0,
  alt: "EN"
}
const _hoisted_7 = {
  key: 1,
  class: "cl-lang-flag",
  src: _imports_1,
  alt: "SE"
}
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = {
  class: "cl-topbar__user-btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = { class: "cl-topbar__hi" }
const _hoisted_12 = { style: {"color":"var(--cl-medium-blue)"} }
const _hoisted_13 = { class: "cl-topbar__avatar" }
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_15 = { class: "cl-dark-mode-switch" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = {
  class: "modal fade",
  id: "userProfileModal",
  tabindex: "-1",
  "aria-labelledby": "userProfileModalLabel",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = { class: "modal-body user-profile-modal" }
const _hoisted_22 = { class: "user-profile-header text-center" }
const _hoisted_23 = { class: "user-profile-name mb-1" }
const _hoisted_24 = { class: "user-profile-email mb-0" }
const _hoisted_25 = {
  class: "nav nav-tabs user-profile-tabs",
  role: "tablist"
}
const _hoisted_26 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_27 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_28 = { class: "tab-content pt-3" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "mb-3 form-group" }
const _hoisted_32 = { class: "form-label" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "mb-3 form-group" }
const _hoisted_35 = { class: "form-label" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "mb-3 form-group" }
const _hoisted_39 = { class: "form-label" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "mb-3 form-group" }
const _hoisted_44 = { class: "form-label" }
const _hoisted_45 = { class: "password-input-wrapper" }
const _hoisted_46 = ["type"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "mb-3 form-group" }
const _hoisted_50 = { class: "form-label" }
const _hoisted_51 = { class: "password-input-wrapper" }
const _hoisted_52 = ["type"]
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "mb-3 form-group" }
const _hoisted_56 = { class: "form-label" }
const _hoisted_57 = { class: "password-input-wrapper" }
const _hoisted_58 = ["type"]
const _hoisted_59 = { class: "modal-footer user-profile-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "cl-sidebar__toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ctx.emit('toggle'))),
          title: 'Toggle sidebar'
        }, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("i", { class: "bi bi-layout-sidebar cl-sidebar__toggle-icon" }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            (_ctx.props.multilang.en)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.props.multilang.se)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.languageChangeEvent('en')), ["prevent"]))
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("img", {
                  class: "cl-lang-flag me-2",
                  src: _imports_0,
                  alt: "EN"
                }, null, -1),
                _createTextVNode(" English ", -1)
              ]))])
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("li", null, [
              _createElementVNode("hr", { class: "dropdown-divider" })
            ], -1)),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.languageChangeEvent('se')), ["prevent"]))
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("img", {
                  class: "cl-lang-flag me-2",
                  src: _imports_1,
                  alt: "SE"
                }, null, -1),
                _createTextVNode(" Swedish ", -1)
              ]))])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _cache[26] || (_cache[26] = _createTextVNode("Hi,  ", -1)),
              _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.authorName), 1)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.authorInitial), 1)
          ]),
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onChangeProfileUser()), ["prevent"]))
              }, [
                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-user me-2" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('myProfile')), 1)
              ])
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("li", null, [
              _createElementVNode("hr", { class: "dropdown-divider" })
            ], -1)),
            _createElementVNode("li", null, [
              _createElementVNode("label", {
                class: "cl-dark-mode-toggle dropdown-item",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.isDarkMode ? 'fas fa-moon me-2' : 'fas fa-sun me-2')
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.isDarkMode ? 'Dark Mode' : 'Light Mode'), 1)
                ]),
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.isDarkMode,
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
                  }, null, 40, _hoisted_16),
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "cl-dark-mode-switch__track" }, null, -1))
                ])
              ])
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("li", null, [
              _createElementVNode("hr", { class: "dropdown-divider" })
            ], -1)),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.logOut()), ["prevent"]))
              }, [
                _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-sign-out-alt me-2" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('signOut')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "user-profile-avatar" }, [
                _createElementVNode("i", { class: "fas fa-user" })
              ], -1)),
              _createElementVNode("h5", _hoisted_23, _toDisplayString(`${_ctx.userProfile.firstName || ''} ${_ctx.userProfile.lastName || ''}`.trim()), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.userProfile.email), 1)
            ]),
            _createElementVNode("ul", _hoisted_25, [
              _createElementVNode("li", _hoisted_26, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activeProfileTab === 'info' }]),
                  type: "button",
                  role: "tab",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeProfileTab = 'info'))
                }, _toDisplayString(_ctx.$t('personalInfo')), 3)
              ]),
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activeProfileTab === 'password' }]),
                  type: "button",
                  role: "tab",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeProfileTab = 'password'))
                }, _toDisplayString(_ctx.$t('changePassword')), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeProfileTab === 'info' }]),
                role: "tabpanel"
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _createTextVNode(_toDisplayString(_ctx.$t('first') + ' ' + _ctx.$t('name')) + " ", 1),
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userProfile.firstName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.userProfile.firstName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, [
                        _createTextVNode(_toDisplayString(_ctx.$t('last') + ' ' + _ctx.$t('name')) + " ", 1),
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userProfile.lastName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.userProfile.lastName]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, [
                        _createTextVNode(_toDisplayString(_ctx.$t('email')) + " ", 1),
                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userProfile.email) = $event)),
                        disabled: _ctx.isUpdate,
                        required: ""
                      }, null, 8, _hoisted_40), [
                        [_vModelText, _ctx.userProfile.email]
                      ])
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeProfileTab === 'password' }]),
                role: "tabpanel"
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.$t('oldPassword')) + " ", 1),
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.showOldPassword ? 'text' : 'password',
                          class: "form-control form-control-sm password-input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.changePasswordForm.oldPassword) = $event)),
                          required: ""
                        }, null, 8, _hoisted_46), [
                          [_vModelDynamic, _ctx.changePasswordForm.oldPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm password-toggle-btn",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showOldPassword = !_ctx.showOldPassword))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye')
                          }, null, 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _createTextVNode(_toDisplayString(_ctx.$t('newPassword')) + " ", 1),
                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.showNewPassword ? 'text' : 'password',
                          class: "form-control form-control-sm password-input",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.changePasswordForm.newPassword) = $event)),
                          required: ""
                        }, null, 8, _hoisted_52), [
                          [_vModelDynamic, _ctx.changePasswordForm.newPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm password-toggle-btn",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showNewPassword = !_ctx.showNewPassword))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye')
                          }, null, 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, [
                        _createTextVNode(_toDisplayString(_ctx.$t('confirmPassword')) + " ", 1),
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.showConfirmPassword ? 'text' : 'password',
                          class: "form-control form-control-sm password-input",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.changePasswordForm.confirmPassword) = $event)),
                          required: ""
                        }, null, 8, _hoisted_58), [
                          [_vModelDynamic, _ctx.changePasswordForm.confirmPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm password-toggle-btn",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showConfirmPassword = !_ctx.showConfirmPassword))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye')
                          }, null, 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-close",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.close()))
            }, [
              _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
            ]),
            (_ctx.activeProfileTab === 'info')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-outline-info-reverse",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onUpdateProfileUser && _ctx.onUpdateProfileUser(...args)))
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('update')), 1)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-sm btn-outline-info-reverse",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onChangePasswordFromProfile && _ctx.onChangePasswordFromProfile(...args)))
                }, [
                  _cache[41] || (_cache[41] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('change')), 1)
                ]))
          ])
        ])
      ])
    ])
  ], 64))
}